import { FormikProvider, useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Card, CardSubtitle, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../UserManagement.scss';
import { useTranslation } from 'react-i18next';
import { ARCHITECT_PROFILE_PERSONAL_DETAILS, PROFILE_STEPS, ARCH_PROFILE_LICENSE_DETAILS, ARCHITECT_PROFILE_DOCS_DETAILS, ARCH_PROFILE_STEPS } from '../UserManagement.const';
import GenericBackButton from '../../../../components/UI components/Buttons/GenericBackButton';
import GenericFormCard from '../../../../components/moduleCommonFormik/GenericFormCard.component';
import HeaderComponent from '../../../../components/header/Header.component';
import SideCard from '../../../../components/moduleCommonFormik/SideCardGenericComponent';
import ScrollToTop from '../../../../components/ScrollToTop';
import ProfileHeader from '../../../../components/Profile section/ProfileHeader';
import { POST, endpoints, requestInfo, getDropdownOptions, updatePassword } from '../../../../services/modulesServices/userManagement.api';
import { getArcInitialData } from '../UserMangement.controller';
import GenericButtons from '../../../../components/UI components/Buttons/GenericButtons';
import ForgotPassword from '../../../loginPage/ForgotPassword';
import { FormDataDTO, CONSTANT_DATA_FIELD, KYC_ESIGN_FLAG, TENANT_ID } from '../../../../utils/constants';
import { DocumentDetails, FileEnum, NextValidActionItem } from '../../../../components/moduleCommonFormik/GenericFormCard.constants';
import Loading from '../../../../components/portalComponents/Loading.component';
import GenericHeader from '../../../../components/moduleCommonFormik/GenericHeader';
import StatusAlertPopup from '../../../../components/moduleCommonFormik/StatusAlertPopup';
import { cross, check } from '../../../../utils/Logo';
import GenericFooterComponent from '../../../../components/moduleCommonFormik/GenericFooter.component';
import { isEqual } from 'lodash';
import { ARCHITECT_PROFILE_VALIDATION, PasswordChangeSchema } from '../../../../utils/formikValidation/FormikValidation';

export default function ArchitectMyProfile() {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState<number>(1);
    const [dropdownData, setDropdownData] = useState<any>([]);
    const [profileData, setProfileData] = useState<any>(ARCHITECT_PROFILE_PERSONAL_DETAILS);
    const [enabledSection, setEnableSection] = useState<any>([]);
    const [responseData, setResponseData] = useState<any>({});
    const [profilePhoto, setProfilePhoto] = useState<any>(null);
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [modalDetails, setModalDetails] = useState<any>({});
    const [nextValidAction, setNextValidAction] = useState<any>(null);
    const [hideCheckbox, setHideCheckbox] = useState<boolean>(true);
    const [progressBarDetails, setProgressBarDetails] = useState<any>(null);
    const [initalValues, setInitialValues] = useState<any>(null);

    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const updateWorkflow = params.get('update');
    const regNo = params.get('applicationNumber');

    const userInfo = JSON.parse(localStorage.getItem('user') || 'null');
    const userType = localStorage.getItem('type');
    const formik = useFormik<any>({
        initialValues: {
            isUpdatable: true
        },
        onSubmit: value => {},
        validationSchema: activeIndex === 1 ? ARCHITECT_PROFILE_VALIDATION : PasswordChangeSchema
    });
    const { values, setValues, setFieldValue, errors } = formik;
    const isSubmitEnabled = values.oldPassword && values.newPassword && values.confirmNewPassword && !errors.oldPassword && !errors.newPassword && !errors.confirmNewPassword;

    const handleScroll = () => {
        if (window.scrollY > 110) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        getDropdownOptions()
            .then((res: any) => {
                setDropdownData(res);
            })
            .catch((err: any) => console.log(err));

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                let response;
                if (updateWorkflow) {
                    response = await POST(endpoints.updateEmpProfileSearch + `?registrationNumber=${regNo}`, { RequestInfo: requestInfo() });
                } else {
                    response = await POST(endpoints.searchEmployee + `&uuids=${userInfo.uuid}`, { RequestInfo: requestInfo() });
                }
                const initData = await getArcInitialData(response.data.Employees[0], dropdownData);
                setValues((prev: any) => ({ ...prev, ...initData }));
                setInitialValues({ ...values, ...initData });
                setResponseData(response.data.Employees[0]);

                const photo = initData['profilePic'];
                setProfilePhoto(photo);
                setIsLoading(false);

                if (regNo) {
                    const { data } = await POST(endpoints.nextValidAction + `?businessId=${regNo}&tenantId=ga`, { RequestInfo: requestInfo() });
                    setNextValidAction(data);
                }
            } catch (error) {
                setIsLoading(false);
            }
        })();
    }, [dropdownData, regNo]);

    const handleOnEditSection = (heading: any, isEditing: boolean) => {
        let newData = [];
        if (isEditing) {
            newData = profileData.map((item: any) => {
                if (item.type === heading) {
                    const formData = item.formData.map((fieldItem: FormDataDTO) => ({
                        ...fieldItem,
                        isDisabled: !fieldItem.isEditable
                    }));
                    if (item.title === 'Present Address') {
                        let addressProof = { titleCode: 'UPLOAD_ADDRESS_PROOF', title: 'Upload address proof', field: 'addressProofDocument', type: CONSTANT_DATA_FIELD.FILE_FIELD, isEditable: true };
                        formData.push(addressProof);
                        setHideCheckbox(false);
                    }
                    return { ...item, formData };
                }
                return item;
            });
            setEnableSection([...enabledSection, heading]);
        } else {
            newData = profileData.map((item: any) => {
                if (item.type === heading) {
                    const formData = item.formData.map((fieldItem: FormDataDTO) => ({
                        ...fieldItem,
                        isDisabled: true
                    }));
                    if (item.title === 'Present Address') {
                        let addressProof = { titleCode: 'UPLOAD_ADDRESS_PROOF', title: 'Upload address proof', field: 'addressProof', type: CONSTANT_DATA_FIELD.FILE_FIELD, isEditable: true };
                        formData.pop(addressProof);
                        setHideCheckbox(true);
                    }
                    return { ...item, formData };
                }
                return item;
            });
            const editableSection = enabledSection.filter((item: string) => item !== heading);
            setEnableSection(editableSection);
        }
        setProfileData(newData);
    };

    const handleStepClick = async (index: number) => {
        if (index > activeIndex) {
            try {
                setActiveIndex(index);
                window.scrollTo(0, 0);
            } catch (e) {
                let errMsg = t('FILL_REQUIRED_DETAILS', 'Fill in all the required details');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        } else setActiveIndex(index);
    };

    useEffect(() => {
        if (formik.errors.profilePhoneNo === 'Mob no. already exists') {
            formik.setFieldValue('profilePhoneNoOtpReferenceId', '');
        } else if (formik.errors.profileEmailId === 'Email already exists') {
            formik.setFieldValue('profileEmailIdOtpReferenceId', '');
        }
    }, [formik.errors.profilePhoneNo, formik.errors.profileEmailId]);

    const handleOnSubmit = async (selectedAction?: any, comment?: string) => {
        if (!regNo && isEqual(initalValues, values)) {
            let errMsg = 'No changes detected';
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            return;
        }

        if (
            (values.profilePhoneNo != responseData.user.mobileNumber && !values.profilePhoneNoOtpReferenceId) ||
            (values.profileEmailId !== responseData.user.profileEmailId && !values.profileEmailIdOtpReferenceId)
        ) {
            let errMsg = 'Verification Needed';
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            return;
        }

        let docs = responseData.documents.map((doc: DocumentDetails) => {
            if (doc.referenceType === 'ADDRESS_PROOF' && values.addressProofDocument) {
                return {
                    documentName: values.addressProofDocument?.documentName,
                    documentType: doc.documentType || '',
                    documentId: values.addressProofDocument.referenceId,
                    referenceType: FileEnum['Address Proof'],
                    referenceId: values.addressProofDocument.referenceId, //id
                    documentSize: values.addressProofDocument?.documentSize,
                    uploadedDate: values.addressProofDocument?.uploadedDate,
                    tenantid: TENANT_ID
                };
            } else return doc;
        });

        const payload = {
            RequestInfo: requestInfo(),
            Employees: [
                {
                    ...responseData,
                    user: {
                        ...responseData.user,
                        mobileNumber: (values.profilePhoneNoOtpReferenceId && values.profilePhoneNo) || responseData.user.mobileNumber,
                        profileEmailId: (values.profileEmailIdOtpReferenceId && values.profileEmailId) || responseData.user.profileEmailId,
                        permanentAddress1: values.peraddress1 || responseData.user.permanentAddress1,
                        permanentAddress2: values.peraddress2 || responseData.user.permanentAddress2,
                        permanentDistrict: values.perdistrict || responseData.user.permanentDistrict,
                        permanentState: values.perstate || responseData.user.permanentState,
                        permanentCountry: values.percountry || responseData.user.permanentCountry,
                        permanentPinCode: values.perpincode || responseData.user.permanentPinCode,
                        correspondenceAddress1: values.address1 || responseData.user.correspondenceAddress1,
                        correspondenceAddress2: values.address2 || responseData.user.correspondenceAddress2,
                        correspondenceDistrict: values.district || responseData.user.correspondenceDistrict,
                        correspondenceState: values.state || responseData.user.correspondenceState,
                        correspondenceCountry: values.country || responseData.user.correspondenceCountry,
                        correspondencePinCode: values.pincode || responseData.user.correspondencePinCode
                    },
                    documents: docs
                }
            ]
        };

        try {
            setIsLoading(true);
            const { data }: any = await POST(endpoints.updateEmpProfile, payload);
            setModalDetails({
                show: true,
                title: 'Profile Updated Successfully',
                img: check,
                type: 'success',
                reUpload: 'OK'
            });
            setIsLoading(false);
        } catch (err: any) {
            setIsLoading(false);
            let errMsg = err.response.data?.errorMessage || err.response.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
            setModalDetails({ show: true, title: 'Employee Profile Update Failed', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const onSubmitChangePassword = async () => {
        if (!values.newPassword) {
            let errMsg = t('NEW_PASSWORD_REQUIRED', 'New Password is a required field.');
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            return;
        }

        if (!values.confirmNewPassword) {
            let errMsg = t('CONFIRM_PASSWORD_REQUIRED', 'Confirm Password is a required field.');
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            return;
        }

        if (values.oldPassword === values.newPassword) {
            let errMsg = t('OLD_PASSWORD_WARNING', 'For security reasons, please select a new password that is different from your previous one.');
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            return;
        }
        if (values.newPassword !== values.confirmNewPassword) {
            let errMsg = t('PASSWORD_MISMATCH_WARNING', 'New password and confirm password do not match.');
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            return;
        }
        try {
            await updatePassword(responseData?.code, values);
            let msg = t('PASSWORD_UPDATED_SUCCESS', 'Password updated successfully');
            setModalDetails({ show: true, title: 'Success', para: msg, img: check, type: 'success', reUpload: 'OK' });
        } catch (e) {
            let errMsg = t('PASSWORD_UPDATE_FAILED', 'Password update failed');
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const handleModalClose = (type: string) => {
        setModalDetails({});
        if (type === 'success') navigate('/goa-idc/architectdashboard');
    };

    const renderProfilePersonalDetails = () => {
        return (
            <>
                <Card className='card_border'>
                    <ProfileHeader name={`${values?.name}`} designation={`${values?.designation?.name ? values?.designation?.name : ''}`} showEditIcon={!(nextValidAction?.isUpdatable === false)} />
                    <Card.Body>
                        {profileData.map((val: any, id: number) => (
                            <GenericFormCard
                                {...val}
                                isEditable={!(nextValidAction?.isUpdatable === false) ? val.isEditable : false}
                                dropdownOptions={dropdownData}
                                handleOnEdit={handleOnEditSection}
                                enabledSection={enabledSection}
                                module='usermanagement'
                                hideAddressCheckbox={hideCheckbox}
                            />
                        ))}

                        {/* <label htmlFor='License Details' className='formHeading'>
                            License Details
                        </label> */}

                        {ARCH_PROFILE_LICENSE_DETAILS.map((val: any, id: number) => (
                            <GenericFormCard
                                {...val}
                                isEditable={!(nextValidAction?.isUpdatable === false) ? val.isEditable : false}
                                dropdownOptions={dropdownData}
                                handleOnEdit={handleOnEditSection}
                                enabledSection={enabledSection}
                                module='usermanagement'
                                hideAddressCheckbox={hideCheckbox}
                            />
                        ))}

                        {ARCHITECT_PROFILE_DOCS_DETAILS.map((val: any, id: number) => (
                            <GenericFormCard {...val} />
                        ))}
                    </Card.Body>
                </Card>
            </>
        );
    };

    const changePassword = () => {
        return (
            <>
                <Card className='card_border mb-4'>
                    <Card.Body>
                        <div className='container'>
                            <h3 className='change_password_heading mt-3'>Change Password</h3>
                            <ForgotPassword />
                        </div>
                        <div className='col-sm-12 ps-3 my-3'>
                            <h1 className='password_policy_heading'>Password Policy</h1>
                            <p className='col-sm-6 pe-2'>Password should be minimum 8 characters long, one lowercase, one uppercase, one digit, one special character.</p>
                        </div>
                    </Card.Body>
                </Card>
            </>
        );
    };

    return (
        <>
            {!!isLoading && <Loading />}
            <HeaderComponent />

            <div className='employee-creation-container bg-light m-auto px-5 py-4 row'>
                <GenericHeader
                    text={updateWorkflow ? t('EMPLOYEE_PROFILE_UPDATE', 'Employee Profile Update') : t('MY_PROFILE', 'My Profile')}
                    registrationNo={updateWorkflow ? regNo : ''}
                    bottomSubText={!updateWorkflow ? `${t('ARCHITECT_ENGINEER_ID', 'Architect/Engineer Id')} - ${responseData?.code}` : ''}
                />
                <div className='col-3 stickyCard-section'>
                    <div className='stickyCard' style={{ top: '110px' }}>
                        <Card className={`card_border  hiddenNav  ${isVisible ? '' : 'scrolledNav'}`}>
                            <Card.Body className=''>
                                <div className='d-flex align-items-center'>
                                    <GenericBackButton />
                                    <div className='ps-1'>
                                        <Card.Text className='font-inter-med fs-5 mb-0 form-header-text'>
                                            {updateWorkflow ? `${t('EMPLOYEE_PROFILE_APPLICATION', 'Employee Profile Application')} - ${regNo}` : t('MY_PROFILE', 'My Profile')}
                                        </Card.Text>
                                        <CardSubtitle className='text-muted text-nav font-inter p-0 m-0'>
                                            {!updateWorkflow ? `${t('ARCHITECT_ENGINEER_ID', 'Architect/Engineer Id')} - ${responseData?.code}` : ''}
                                        </CardSubtitle>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                        <Card className='card_border p-3'>
                            <Card.Body>
                                <Card.Text className=' d-flex flex-column  row-gap-3'>
                                    <SideCard steps={ARCH_PROFILE_STEPS} activeIndex={activeIndex} handleStepClick={handleStepClick} />
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <div className='col-9 form-section'>
                    <FormikProvider value={formik}>
                        <Form>
                            {activeIndex === 1 && renderProfilePersonalDetails()}
                            {activeIndex === 2 && changePassword()}
                        </Form>
                    </FormikProvider>
                </div>
            </div>
            <ScrollToTop />
            <div className='common-footer'>
                {/* {updateWorkflow ? (
                    <GenericFooterComponent
                        onCancel={() => navigate(-1)}
                        stepperLength={1}
                        activeIndex={1}
                        onSubmit={() => {}}
                        nextValidAction={nextValidAction}
                        applicationNo={regNo || null}
                        handleOnPrimaryAction={handleOnSubmit}
                    />
                ) : (
                    <GenericButtons text={t('SUBMIT', 'Submit')} type='submit' variant='primary' ClassName='me-5' handleClick={activeIndex === 1 ? handleOnSubmit : onSubmitChangePassword} />
                )} */}

                {activeIndex === 1 && <GenericButtons text={t('SUBMIT', 'Submit')} type='submit' variant='primary' ClassName='me-5' handleClick={handleOnSubmit} />}
                {activeIndex === 2 && <GenericButtons text={t('SUBMIT', 'Submit')} type='submit' variant='primary' ClassName='me-5' handleClick={onSubmitChangePassword} />}
            </div>
            <StatusAlertPopup
                title={modalDetails.title}
                para={modalDetails.para}
                img={modalDetails.img}
                show={modalDetails.show}
                handleClose={() => handleModalClose(modalDetails.type)}
                type={modalDetails.type}
                reUpload={modalDetails.reUpload}
                handleSubmit={() => handleModalClose(modalDetails.type)}
            />
        </>
    );
}
